import { Box, Button,  FormLabel,  Paper, Stack, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { format } from "date-fns";
import { Link as RouterLink } from "react-router-dom";
import { ConditionalBox } from "../../../../utils/ConditionalBox";
import { DebugBox } from "@northpowerdev/np-react-utils";
import ImageListBox from "../../../upload/ImageListBox";

const LocalStyledPaper = styled(Paper)(({theme}) => ({
    background: '#f1f3fa',
}));

const SummaryText = styled(Typography)(({theme}) => ({
    fontSize: '1.2em',
    fontWeight: 'bold',
}));

// const CommentText = styled(Typography)(({theme}) => ({
//     fontSize: '1.0em',
//     fontWeight: 'bold',
// }));

const StyledRouterLink = styled(RouterLink)(({theme}) => ({
    color: theme.palette.primary.main,
}));

export default function IcpInspectionStepSummary({
    formState: {
        markerLatLng, meterLocationDescription, connectionDate,
        serviceBranchConnection, connectionType, 
        fuseRating, fuseRatingOther, phaseList, rippleControllerPhase,
        loopImpedanceOK, phaseRotation, comments, asBuiltFileObjects,
        loopImpedanceTestLocation, loopImpedanceProblemPhases, loopImpedanceReadings, loopImpedanceAtNetwork,
    },
    onBack,
    onNext,
    sent }) {

    if (sent) {
        return (
            <Stack spacing={2} textAlign="center">
                <LocalStyledPaper sx={{p:2}}>
                    <SummaryText sx={{my:3}} variant="body1">All done.</SummaryText>
                    <StyledRouterLink to="/connect/list_icp_inspections">Go To ICP Inspections List</StyledRouterLink>
                </LocalStyledPaper>

            </Stack>
        )
    }

    // const sendToNorthpowerDisabled = (loopImpedanceOK === 'No')
    const sendToNorthpowerDisabled = false
    return (
        <>
            <Typography variant="h4" sx={{mb:3}}>New Connection Summary</Typography>
            <Stack spacing={2} textAlign="center">
                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>ICP Location</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{JSON.stringify(markerLatLng)}</SummaryText>
                </LocalStyledPaper>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>Meter Location Description</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{meterLocationDescription}</SummaryText>
                </LocalStyledPaper>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>Connection Date</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{format(connectionDate, "d MMMM yyyy")}</SummaryText>
                </LocalStyledPaper>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>Service Branch Connection</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{serviceBranchConnection}</SummaryText>
                </LocalStyledPaper>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>Connection Type</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{connectionType}</SummaryText>
                </LocalStyledPaper>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>Fuse Rating</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{fuseRating === 'Other' ? (fuseRatingOther + ' Amp') : fuseRating }</SummaryText>
                </LocalStyledPaper>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>Phases</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{phaseList?.join(', ')}</SummaryText>
                </LocalStyledPaper>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>Ripple Controller Phase</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{rippleControllerPhase}</SummaryText>
                </LocalStyledPaper>

                <ConditionalBox condition={phaseList?.length === 3}>
                    <LocalStyledPaper sx={{p:2}}>
                        <FormLabel>Phase Rotation OK?</FormLabel>
                        <SummaryText sx={{my:3}} variant="body1">{phaseRotation}</SummaryText>
                    </LocalStyledPaper>
                </ConditionalBox>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>Loop Impedance OK?</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{loopImpedanceOK}</SummaryText>
                </LocalStyledPaper>

                <ConditionalBox condition={loopImpedanceOK === 'No'}>
                    <LocalStyledPaper sx={{p:2}}>
                        <FormLabel>Loop Impedance Test Location</FormLabel>
                        <SummaryText sx={{my:3}} variant="body1">{loopImpedanceTestLocation}</SummaryText>
                    </LocalStyledPaper>
                    <LocalStyledPaper sx={{p:2}}>
                        <FormLabel>Loop Impedance Problem Phases</FormLabel>
                        <SummaryText sx={{my:3}} variant="body1">{loopImpedanceProblemPhases}</SummaryText>
                    </LocalStyledPaper>
                    <LocalStyledPaper sx={{p:2}}>
                        <FormLabel>Loop Impedance Readings (Ohms)</FormLabel>
                        <SummaryText sx={{my:3}} variant="body1">{loopImpedanceReadings}</SummaryText>
                    </LocalStyledPaper>
                    <LocalStyledPaper sx={{p:2}}>
                        <FormLabel>Loop Impedance Readings at Network Connection Point (Ohms)</FormLabel>
                        <SummaryText sx={{my:3}} variant="body1">{loopImpedanceAtNetwork}</SummaryText>
                    </LocalStyledPaper>
                </ConditionalBox>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>Comments</FormLabel>
                    <SummaryText sx={{my:3}} variant="body1">{comments}</SummaryText>
                </LocalStyledPaper>

                <LocalStyledPaper sx={{p:2}}>
                    <FormLabel>As Built Photos</FormLabel>
                    <ImageListBox imageFiles={asBuiltFileObjects} imageWidth={120} />
                    {/* <SummaryText sx={{my:3}} variant="body1">{JSON.stringify(asBuiltFileObjects)}</SummaryText> */}
                </LocalStyledPaper>
            </Stack>

            <Box sx={{ my: 2, display: 'flex', justifyContent: 'space-between' }}>
                <Button onClick={onBack}>Back</Button>
                <Button variant="contained" onClick={onNext} disabled={sendToNorthpowerDisabled}>Send To Northpower</Button>
            </Box>

            <DebugBox title="formData" stringify>{{
        markerLatLng, meterLocationDescription, connectionDate,
        serviceBranchConnection, connectionType, 
        fuseRating, fuseRatingOther, phaseList, rippleControllerPhase,
        loopImpedanceOK, phaseRotation, comments, asBuiltFileObjects,
        loopImpedanceTestLocation, loopImpedanceProblemPhases, loopImpedanceReadings,
    }}</DebugBox>
            {/* {
                sendToNorthpowerDisabled
                &&
                <Box>
                    <Alert severity="error">
                        Northpower does not accept ICP inspection unless loop impedance is OK.
                        Wiring changes are needed to bring loop impedance down to an acceptable level before
                        this ICP inspection can be submitted.
                    </Alert>
                </Box>
            } */}
        </>
    )
}